import TextAreaDisplay from 'components/form/Inputs/TextAreaDisplay';
import GENDERS from 'enums/Genders';
import { RoleValues } from 'enums/Roles';
import { FC } from 'react';
import User from 'types/User';
import { getLocaleDate } from 'utils/time';
import Field from '../../components/profileNavigation/Field';
import Button from '../Button';
import { ChipContainer } from '../Chips/ChipContainers';
import MenteeStatusChip from '../Chips/MenteeStatusChip';
import MentorStatusChip from '../Chips/MentorStatusChip';
import RoleChip from '../Chips/RoleChip';
import { FlexColumn } from '../form/generic';
import LabelledCheckbox from '../form/Inputs/LabelledCheckbox';

type Props = {
  variant: 'mentee' | 'mentor';
  reader: 'admin' | 'mentee' | 'mentor';
  user: User | undefined;
  setStatusOpen?: (value: boolean) => void;
};
const UserInformationDisplay: FC<Props> = ({
  user,
  variant,
  reader,
  setStatusOpen,
}) => {
  return (
    <>
      {reader === 'admin' && (
        <Field label="Rôles">
          <ChipContainer>
            {user?.UserRole?.map((role: { role: RoleValues }, idx: number) => (
              <RoleChip role={role.role} key={idx} />
            ))}
          </ChipContainer>
        </Field>
      )}

      {variant === 'mentor' && reader === 'admin' && (
        <Field label="Statut">
          {user && <MentorStatusChip status={user.mentorStatus!} />}
        </Field>
      )}

      {variant === 'mentee' && (reader === 'admin' || reader === 'mentor') && (
        <Field
          label={
            <>
              <p>Statut</p>
              <Button
                variant="outlined"
                onClick={() => setStatusOpen && setStatusOpen(true)}
              >
                Modifier le statut
              </Button>
            </>
          }
        >
          {user && (
            <MenteeStatusChip
              status={user.menteeStatus!}
              mentorshipStatus={
                (user.MenteeMentorship && user.MenteeMentorship[0]?.status) ||
                'ONGOING'
              }
            />
          )}
        </Field>
      )}

      {variant === 'mentor' && reader === 'admin' && (
        <Field label="Prioritaire">
          <LabelledCheckbox
            label="Ce mentor est prioritaire"
            name="priority"
            checked={!!user?.priority}
            readOnly
          />
        </Field>
      )}

      <Field label="Genre">{user?.gender ? GENDERS[user.gender] : ''}</Field>
      {variant === 'mentee' && reader === 'admin' && (
        <>
          <Field label="Situation de handicap">
            <LabelledCheckbox
              label={user?.isHandicap ? "En situation de handicap" : "Non renseigné"}
              checked={!!user?.isHandicap}
              readOnly
            />
          </Field>
          {user?.isHandicap && user?.handicapDetails && (
            <Field label="Détails du handicap">
              <TextAreaDisplay text={user.handicapDetails} />
            </Field>
          )}
          <Field label="Nationalité">{user?.nationality || 'Non renseignée'}</Field>
        </>
      )}
      <Field label="Nom">{user?.lastName}</Field>
      <Field label="Prénom">{user?.firstName}</Field>
      {(!(
        (variant !== 'mentor' && reader === 'mentee') ||
        (variant !== 'mentee' && reader === 'mentor')
      ) ||
        user?.email) && <Field label="Adresse email">{user?.email}</Field>}

      {reader === 'admin' && (
        <Field label="Commentaires">
          <TextAreaDisplay text={user?.comments || ''} />
        </Field>
      )}

      {(!(
        (variant !== 'mentor' && reader === 'mentee') ||
        (variant !== 'mentee' && reader === 'mentor')
      ) ||
        user?.phone) && (
        <Field label="Numéro de téléphone">{user?.phone || ''}</Field>
      )}

      {!(
        (variant !== 'mentor' && reader === 'mentee') ||
        (variant !== 'mentee' && reader === 'mentor')
      ) && (
        <Field label="Date de naissance">
          {user?.dateOfBirth && (
            <>
              {getLocaleDate(user.dateOfBirth)}
              {reader === 'admin' && (
                <span style={{ marginLeft: '0.5rem', color: 'var(--gray-500)' }}>
                  ({Math.floor(
                    (new Date().getTime() - new Date(user.dateOfBirth).getTime()) /
                    (1000 * 60 * 60 * 24 * 365.25)
                  )} ans)
                </span>
              )}
            </>
          )}
        </Field>
      )}

      {variant === 'mentor' && (
        <Field label="Organisme">{user?.organism || ''}</Field>
      )}

      {!(
        (variant !== 'mentor' && reader === 'mentee') ||
        (variant !== 'mentee' && reader === 'mentor')
      ) && <Field label="Adresse">{user?.address || ''}</Field>}

      {!(
        (variant !== 'mentor' && reader === 'mentee') ||
        (variant !== 'mentee' && reader === 'mentor')
      ) && <Field label="Code postal">{user?.postalCode || ''}</Field>}

      {!(
        (variant !== 'mentor' && reader === 'mentee') ||
        (variant !== 'mentee' && reader === 'mentor')
      ) && <Field label="Ville">{user?.city || ''}</Field>}

      <Field label="Région">{user?.region || ''}</Field>

      <Field label="Pays">
        <FlexColumn gap={1}>
          {user?.country}
          <LabelledCheckbox
            label={
              variant === reader
                ? 'Je vis en France métropolitaine'
                : 'Vit en france métropolitaine'
            }
            checked={!!user?.isMetropolitan}
            readOnly
          />
        </FlexColumn>
      </Field>

      <Field label="Profil">
        {user?.presentation ? (
          <TextAreaDisplay text={user.presentation} />
        ) : null}
      </Field>

      {variant === 'mentor' && reader === 'mentee' && (
        <Field label="Attentes du mentorat">
          <TextAreaDisplay text={user?.MentorForm?.expectations || ''} />
        </Field>
      )}
    </>
  );
};

export default UserInformationDisplay;
